export default "__VITE_ASSET__DNvbs21F__"